import { DynamicStandaloneTrendingMenu } from '@/components/TrendingMenu';
import { LabradorComponent } from '@/types/component';
import withDebugMetadata from '@/utils/withDebugMetadata';

export const LabradorTrendingMenu: LabradorComponent = ({ type, data, meta }) => {
  return (
    <DynamicStandaloneTrendingMenu tags={data.tags} headline={data.headline} {...withDebugMetadata({ type, meta })} />
  );
};

export default LabradorTrendingMenu;
